import Base from '../base.js'
// import { statusResponse } from '../responseService'
export default class Video extends Base {
  constructor () {
    super('/videos')
  }
}
